import { CircularProgress, Tooltip } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import TimeAgo from 'timeago-react'

import { useAppSelector } from 'app/state/hooks'
import useMobileBuilder from 'features/builder/ui/useMobileBuilder'
import useMapSavingState from './useMapSavingState'
import BuilderHeaderChip from '../BuilderHeaderChip'
import { CloudDoneOutlined, CloudOffOutlined, WarningOutlined } from '@mui/icons-material'
import { blockAutoSaveDocMigrationTemporary } from 'features/builder/model/documentModeMigration'

function getAutosaveTitleId(isAutosavingEnabled: boolean, inProgress: boolean) {
  return !isAutosavingEnabled
    ? 'builder.navBar.autosavedDisabled.title'
    : inProgress
    ? 'builder.navBar.updating'
    : 'builder.navBar.updated'
}

function getAutosaveIcon(isAutosavingEnabled: boolean, inProgress: boolean) {
  return !isAutosavingEnabled ? (
    <CloudOffOutlined />
  ) : inProgress ? (
    <CircularProgress color="inherit" size={16} />
  ) : (
    <CloudDoneOutlined />
  )
}

function MapSavingIndicator() {
  const intl = useIntl()
  const isMobile = useMobileBuilder()

  const { currentMap, isLoading, isAutosavingEnabled, saveNeeded } = useMapSavingState()
  const somethingMigratedFromDocumentMode = useAppSelector(blockAutoSaveDocMigrationTemporary)

  return (
    <Tooltip
      title={
        isAutosavingEnabled ? (
          <TimeAgo opts={{ minInterval: 60 }} datetime={currentMap?.updatedAt || ''} />
        ) : (
          <FormattedMessage id="builder.navBar.autosavedDisabled.msg" />
        )
      }
      placement="bottom"
    >
      <div>
        <BuilderHeaderChip
          icon={<div>{getAutosaveIcon(isAutosavingEnabled, isLoading || saveNeeded)}</div>}
          label={
            !isMobile &&
            intl.formatMessage({
              id: getAutosaveTitleId(isAutosavingEnabled, isLoading || saveNeeded)
            })
          }
          aria-label="map-save-status"
        />
        {somethingMigratedFromDocumentMode && (
          <BuilderHeaderChip icon={<WarningOutlined />} label="Migrated from document mode" />
        )}
      </div>
    </Tooltip>
  )
}

export default MapSavingIndicator
